module.exports = __webpack_public_path__ + "img/103-913044.png";